import { createH5App } from './app';

// 不做 declare global 扩充：四端入口同在一个 tsc 工程（tsconfig include 四端 src），各自声明不同类型的 Window.GPApp 会冲突；
// support.js 只在运行时读取 window.GPApp，故以属性定义挂载（四端入口同一写法）。
Object.defineProperty(window, 'GPApp', { value: createH5App({ dev: import.meta.env.DEV }), configurable: true, writable: true });
